/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import 'react-toastify/dist/ReactToastify.css'
import notifyToast from '../../../components/Toast/Toast'
import {ToastContainer} from 'react-toastify'
import TitleComponent from '../../../components/TitleComponent/TitleComponent'
import {useParams} from 'react-router-dom'
import LoadingComponent from '../../../components/LoadingComponent/LoadingComponent'
import {fetchSifra, saveSifra, updateSifra} from '../../../api/paneliSifre'
import {PanelSifre} from '../../../models/PanelSifarniciModel'

interface Props {
  // other potential props go here
}

const SifreDodaj: React.FC<Props> = () => {
  const {id} = useParams()
  const IdFromURL = Number(id)

  const [loading, setLoading] = useState(true)

  const initialValues = {
    sifra: '',
    tezina: '',
  }
  const [initialData, setInitialData] = useState<Partial<PanelSifre>>(initialValues)

  useEffect(() => {
    if (IdFromURL) {
      fetchSifra(IdFromURL)
        .then((data) => {
          setInitialData(data)
          formik.resetForm({values: data}) // <-- reset formik state here
        })
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [IdFromURL])

  const validationSchema = Yup.object({
    sifra: Yup.string().min(4, 'Must be at least 4 characters').required('Required'),
    tezina: Yup.string().min(2, 'Must be at least 2 characters').required('Required'),
  })

  const formik = useFormik({
    initialValues: initialData,
    validationSchema: validationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        let response
        if (IdFromURL) {
          response = await updateSifra(values, IdFromURL)
        } else {
          response = await saveSifra(values)
        }
        if (response.error === 0) {
          notifyToast(true, response.message)
        } else {
          notifyToast(false, response.message || 'An unexpected error occurred.')
        }
      } catch (error) {
        console.error('Error: ', error)
        notifyToast(false, 'Error')
        setStatus(error)
      } finally {
        setLoading(false)
        setSubmitting(false)
      }
    },
  })
  return (
    <div className='card mb-5 mb-xl-10'>
      <ToastContainer />
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <TitleComponent name='Šifru' />
        </div>
      </div>
      <div id='kt_account_profile_details' className='collapse show'>
        {loading ? (
          <LoadingComponent />
        ) : (
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              {/* Naziv */}
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Naziv </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    placeholder='Naziv'
                    {...formik.getFieldProps('sifra')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.sifra && formik.errors.sifra},
                      {
                        'is-valid': formik.touched.sifra && !formik.errors.sifra,
                      }
                    )}
                  />
                  {formik.touched.sifra && formik.errors.sifra && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.sifra}</div>
                    </div>
                  )}
                </div>
              </div>
              {/* Tezina */}
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Težina </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='number'
                    placeholder='Težina'
                    {...formik.getFieldProps('tezina')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.tezina && formik.errors.tezina},
                      {
                        'is-valid': formik.touched.tezina && !formik.errors.tezina,
                      }
                    )}
                  />
                  {formik.touched.tezina && formik.errors.tezina && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.tezina}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button
                type='submit'
                className='btn btn-primary'
                disabled={loading || formik.isSubmitting || !formik.isValid}
              >
                {!loading && 'Potvrdi'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
export default SifreDodaj
